<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button round icon="el-icon-back" @click="$emit('back', 'type')">返回</el-button>
    </div>

    <div class="summary-section">
      <div class="total-amount"
        >訂單總計 <span class="highlight">NT$ {{ paymentInfo.total }}</span></div
      >
      <div class="method-label">{{ currentInfo.title }}</div>
    </div>

    <!-- <div class="content-wrapper">
      <div class="input-card">
        <div class="invoice-toggle-row">
          <el-checkbox v-model="isNeedInvoice" :disabled="!isNeedInvoice">是否開立發票</el-checkbox>
        </div>

        <el-form :disabled="!isNeedInvoice" label-position="top" :model="invoiceData" class="invoice-dialog">
          <el-form-item required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">
                開立類型
              </span>
            </template>
            <el-select v-model="invoiceData.type" placeholder="請選擇" style="width: 100%">
              <el-option label="個人" value="individual" />
              <el-option label="公司" value="company" />
              <el-option label="捐贈發票" value="donation" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="invoiceData.type === 'individual'">
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">
                載具類別
              </span>
            </template>
            <el-select v-model="invoiceData.carrier" style="width: 100%">
              <el-option label="無 (寄送電子發票至客戶 email)" value="none" />
              <el-option label="手機條碼" value="phone" />
              <el-option label="自然人憑證條碼" value="citizen" />
              <el-option label="ezPay 電子發票載具" value="ezpay" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div> -->

    <div class="content-wrapper">
      <div class="input-card">
        <template v-if="type === 'Credit'">
          <p class="input-guide">是否確認使用線上信用卡付款？</p>
          <div class="button-group">
            <el-button round type="primary" class="btn-confirm" @click="$emit('fetchPayMethod', 'Credit')">確認付款</el-button>
          </div>
        </template>

        <template v-else-if="type === 'Vacc'">
          <div class="form-group">
            <div class="bank-selector">
              <p class="selector-label">請選擇轉帳銀行</p>
              <el-select v-model="selectedBank" placeholder="請選擇銀行" style="width: 100%">
                <el-option v-for="bank in bankOptions" :key="bank.code" :label="bank.name" :value="bank.type" />
              </el-select>
            </div>

            <p class="input-guide">是否確認使用虛擬帳戶付款？</p>
            <div class="button-group">
              <el-button round type="primary" class="btn-confirm" @click="handleVaccConfirm" :disabled="!selectedBank">確認付款</el-button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step4OnlineForm',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({ total: 0, vaccBanks: [] }),
    },
    type: {
      type: String,
      default: '',
    },
    containerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedBank: '',
      invoiceVisible: false,
      formData: { code: '' },
      invoiceData: { type: 'individual', carrier: 'ezpay' },
      isNeedInvoice: false,
    }
  },
  computed: {
    currentInfo() {
      const maps = {
        Credit: { title: '線上信用卡' },
        Vacc: { title: '虛擬帳戶' },
      }
      return maps[this.type] || { title: '' }
    },
    bankOptions() {
      return this.paymentInfo.vaccBanks || []
    },
  },
  methods: {
    handleVaccConfirm() {
      this.$emit('next', { key: 'bankType', value: this.selectedBank })
      this.$emit('fetchPayMethod', 'Vacc')
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-selection-container {
  padding: 20px;
  background-color: #fcfcfc;

  .header-actions {
    margin-bottom: 20px;
  }

  .summary-section {
    text-align: center;
    margin-bottom: 30px;
    .total-amount {
      font-size: 1.2rem;
      .highlight {
        color: #ea6a2a;
        font-weight: bold;
      }
    }
    .method-label {
      margin-top: 10px;
      color: #666;
    }
  }

  .content-wrapper {
    margin-bottom: 20px;
  }

  .input-card {
    background: #fff;
    max-width: 600px;
    margin: 0 auto;
    padding: 40px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

    .invoice-toggle-row {
      padding-bottom: 15px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 20px; /* 增加一點間距 */
    }

    // 統一處理 Checkbox 樣式
    ::v-deep .el-checkbox {
      display: flex;
      align-items: center;
      justify-content: center; // 讓整個控制項在卡片居中

      // 1. 放大方框本體
      .el-checkbox__inner {
        width: 20px !important; // 稍微加大到 20px 視覺效果更好
        height: 20px !important;
        border-radius: 4px; // 稍微圓角一點比較現代

        // 2. 精確定位內部的勾勾 (針對 20px 框計算)
        &::after {
          height: 10px !important;
          width: 5px !important;
          left: 6px !important; // 修正水平居中
          top: 2px !important; // 修正垂直居中
          border-width: 2px !important;
        }
      }

      // 3. 放大文字
      .el-checkbox__label {
        font-weight: 500;
        font-size: 18px !important; // 20px 框配 18px 字比較平衡
        line-height: 20px;
        padding-left: 10px;
      }
    }

    .form-group {
      .bank-selector {
        margin-bottom: 30px;

        .selector-label {
          font-size: 1.1rem;
          color: #303133;
          margin-bottom: 20px;
          font-weight: 500;
        }

        ::v-deep .el-select {
          .el-input__inner {
            height: 50px;
            text-align: center;
            font-size: 1.1rem;
            border-radius: 4px;
            border-color: #ebeef5;
          }
        }
      }
    }

    .input-guide {
      font-size: 1.1rem;
      color: #303133;
      margin-bottom: 30px;
    }

    .button-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .el-button {
        width: 100%;
        height: 50px;
        margin: 0;
        font-size: 1rem;
      }
      .btn-confirm {
        background: #ea6a2a;
        border-color: #ea6a2a;
        color: #fff;
        margin-top: 16px;
      }
      .btn-later {
        color: #666;
        border-color: #dcdfe6;
      }
    }
  }
}

/* 針對發票區塊的樣式 */
.invoice-dialog {
  .dialog-footer {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .el-button {
      width: 100%;
      height: 45px;
      margin: 0;
    }
    .btn-confirm {
      background: #ea6a2a;
      border-color: #ea6a2a;
      color: #fff;
    }
  }
}
</style>
